/**
 * Try to use separate files in /components/
 *
 * IMPORTANT: If you want to use jQuery, make sure you enqueue it first.
 * Since it is only registered in actions.php
 */

import './components/offcanvas';
import './components/delay-search-queries';
import './components/video';
import './components/footer-menus';
import './components/scroll-to-top';
import './components/foundation.app';
import './components/accessibility';
import './components/lazy.jquery';
import './components/copy-link';
import './components/wp-gallery-swiper';
import './components/vacancies';
import './components/sticky-header-scroll';
import './components/testimonials-slider';
import './components/form-toggles';
